export default "__VITE_ASSET__T0FsZOyp__"